import { Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { OverlayBadgeModule } from 'primeng/overlaybadge';

@Component({
    selector: 'apcam-notifications-badge',
    templateUrl: './notifications-badge.component.html',
    styleUrls: ['./notifications-badge.component.scss'],
    imports: [
        MatButtonModule,
        MatIconModule,
        OverlayBadgeModule,
        TranslatePipe,
    ],
})
export class NotificationsBadgeComponent {
    notificationCount = input.required<number>();

    dialogOpen = output();

    protected readonly hasNotifications = computed(
        () => this.notificationCount() > 0
    );
}
